import { CSSProperties } from 'react';

import { useAlerting, useTranslation } from '../hooks';
import { copyToClipboard } from '../utils';
import { Box, Tooltip } from './MuiGenerals';

interface Iprops {
  text: string;
  sx?: CSSProperties;
  noToolTip?: boolean;
  amendedText?: string;
}

export default function CopyableText({ text, sx, noToolTip, amendedText }: Iprops) {
  const { tc } = useTranslation();
  const { alerting } = useAlerting();
  const handleCopyText = () => {
    copyToClipboard(text);
    alerting('success', tc('copied'));
  };
  return (
    <Tooltip title={!noToolTip && text}>
      <div style={{ display: 'flex', gap: '4px' }}>
        <Box
          sx={(theme) => ({
            textOverflow: 'ellipsis',
            // whiteSpace: 'nowrap',
            overflow: 'hidden',
            color: theme.palette.primary.main,
            cursor: 'pointer',
            textDecoration: 'underline',
            ...sx,
          })}
          onClick={handleCopyText}
        >
          {text}
        </Box>
        <Box sx={{ color: '#999' }}>{amendedText}</Box>
      </div>
    </Tooltip>
  );
}
